import { buildAgentName } from 'hooks/useGruAgent/helpers';
import { listWorkflows, WorkflowListItem } from 'services/gru/gruApi';
import { logError } from 'services/logging/logging';

export const extractWorkflowToApply = (workflows: Array<WorkflowListItem>) => {
  if (workflows.length === 0) {
    return [];
  }

  const lastWorkflow = workflows[workflows.length - 1];
  if (lastWorkflow.type === 'enrichment' || lastWorkflow.type === 'cross-document-enrichment') {
    return [{ name: 'cross-document-enrichment' as const }];
  }

  return [];
};

export const fetchAppliedWorkflows = async (messageId: string, partnerId: string, isAdmin: boolean) => {
  try {
    const agentName = buildAgentName(messageId, partnerId, isAdmin);
    const workflows = await listWorkflows(agentName);
    return extractWorkflowToApply(workflows);
  } catch (error) {
    logError(error);
    return [];
  }
};
